<template>
    <div>
        <!-- 功能按钮 -->
        <buttonlist @help="help" @add="add" @search="search" @reflash="reflash" @del="delall" @exps="exp" ref="SetBtn"></buttonlist>
        <!-- 功能按钮 -->
        <!-- 表格 -->
        <div>
            <el-button type="primary" size="mini" @click="checkPart" :disabled="!btn.checkPic">{{$t('getapi[6869]')}}</el-button>
            <el-button type="primary" size="mini" @click="checkPic" :disabled="!btn.checkPic">{{$t('getapi[6870]')}}</el-button>
        </div>
        <el-table
                id="xpane-0"
                :data="datajson"
                v-loading="loading"
                :highlight-current-row="false"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                header-row-class-name="headerclass"
                :height="tableHeight"
                @cell-dblclick="editInfo"
                tab-click="selectInfo(0)"
                @selection-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
                :header-cell-style="$limits.headerClass"
                ref="singleTable"
        >
            <el-table-column type="selection"></el-table-column>
            <!--<el-table-column show-overflow-tooltip prop="Exclusively_ID" label="ID"></el-table-column>-->
            <el-table-column show-overflow-tooltip prop="ITEM_CODE" :label="$t('getapi[137]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="ITEM_NAME" :label="$t('getapi[546]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="CLIENT_CODE" :label="$t('getapi[2610]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="ITEM_DUTY_PERSON" :label="$t('getapi[3139]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="QUser_Num_Name" :label="$t('getapi[6871]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="ITEM_PUR_PERSON_NAME" :label="$t('getapi[13172]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="ITEM_SALE_PERSON_NAME" :label="$t('getapi[13173]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="ITEM_DES" :label="$t('getapi[163]')"></el-table-column>

            <el-table-column show-overflow-tooltip prop="ITEM_INTO_DATE" :label="$t('getapi[3361]')"></el-table-column>
            <el-table-column prop="Item_Status" :label="$t('getapi[552]')">
                <template slot-scope="scope">
                    {{scope.row.Item_Status | lanchange}}
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="REMARK" :label="$t('getapi[13171]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[410]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[135]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[733]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="MODIFY_TIME" :label="$t('getapi[734]')"></el-table-column>
            <el-table-column prop="trace_in_name" :label="$t('getapi[6872]')">
                <template scope="scope">
                    <span>{{ scope.row.trace_in_name | lanchange}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="trace_name" :label="$t('getapi[6481]')">
                <template scope="scope">
                    <span>{{ scope.row.trace_name | lanchange}}</span>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="prefix" :label="$t('getapi[6873]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="serial_number" :label="$t('getapi[6874]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="cost_customer_code" :label="$t('getapi[9744]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="job_design_person" :label="$t('getapi[12766]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="isadd_docnodename" :label="$t('getapi[12900]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="device_name" :label="$t('getapi[12984]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="material_planner" :label="$t('getapi[13113]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_assistant" :label="$t('getapi[13114]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="supplier_code" :label="$t('getapi[13153]')"></el-table-column>
            <el-table-column prop="autocalcmaterial" :label="$t('getapi[13517]')">
                <template slot-scope="scope">
                    {{scope.row.autocalcmaterial == 1?$t('getapi[2052]'):$t('getapi[2053]')}}
                </template>
            </el-table-column>
            <el-table-column prop="nofa" :label="$t('getapi[13535]')">
                <template slot-scope="scope">
                    {{scope.row.nofa == 1?$t('getapi[2052]'):$t('getapi[2053]')}}
                </template>
            </el-table-column>
            <el-table-column fixed="right" :label="$t('getapi[6048]')" width="150">
                <template slot-scope="scope">
                    <el-button @click.native.prevent="changestatus(scope,1)"
                               type="text" size="small" :disabled="!btn.editstatus">{{ $t('getapi[552]') }}
                    </el-button>
                    <el-button :disabled="!btn.edit" @click.native.prevent="edit(scope)" type="text" size="small">{{
                        $t('getapi[34]') }}
                    </el-button>
                    <el-popconfirm
                            :confirmButtonText="$t('getapi[6109]')"
                            :cancelButtonText="$t('getapi[6]')"
                            icon="el-icon-info"
                            iconColor="red"
                            :title="$t('getapi[637]')"
                            @onConfirm="del(scope)"
                    >
                        <el-button :disabled="!btn.del" slot="reference" type="text" size="small">{{ $t('getapi[40]')
                            }}
                        </el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <!-- 表格 -->
        <!-- 分页 -->
        <el-row class="page">
            <el-col :span="16">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[50, 100, 200, 300, 400]"
                        :page-size="PageSize"
                        background
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="8">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <!-- 分页 -->
        <!-- 搜索弹框 -->
        <serce :isVisible="isVisible" queryData="ENGITEMLineViewInfo" ref="ser" @getser="serclick"></serce>
        <!-- <el-dialog :visible.sync="isVisible" :title="$t('getapi[3653]')" width="30%">
            <el-tabs type="border-card">
                <el-tab-pane :label="$t('getapi[2020]')">
                    <el-table :data="queryData" border height="400" size="mini" style="width: 100%;">
                        <el-table-column show-overflow-tooltip prop="Field_Show_Name" :label="$t('getapi[2021]')" width="150"></el-table-column>
                        <el-table-column show-overflow-tooltip :label="$t('getapi[2022]')">
                            <template slot-scope="scope">
                                <input type="text" v-model="scope.row.query_Condition" style="border:none" />
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane :label="$t('getapi[2028]')"><div style="min-height: 400px; line-height: 30px;" v-html="hleptext"></div></el-tab-pane>
            </el-tabs>

            <span slot="footer" class="dialog-footer">
                <el-button @click="isVisible = false">{{ $t('getapi[6]') }}</el-button>
                <el-button type="primary" @click="intidata">{{ $t('getapi[937]') }}</el-button>
            </span>
        </el-dialog> -->
        <!-- 搜索弹框 -->
        <!-- 编辑弹框 -->
        <el-dialog v-dialogDrag :visible.sync="editvisi" :title="$t('getapi[34]')" width="40%" :close-on-click-modal="false">

            <el-divider></el-divider>
            <div :style="{border:'1px solid #DCDFE6'}">
                <table>
                    <tr>
                        <td>{{$t('getapi[137]')}}</td>
                        <td><el-input v-model="formInline.item_code" oninput="value=value.replace(/\s*/g,'')" type="text" size="mini" :disabled="addoredit == 2"></el-input></td>
                        <td>{{$t('getapi[546]')}}</td>
                        <td><el-input v-model="formInline.item_name" type="text" size="mini"></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[2610]')}}</td>
                        <td>
                            <routejump :urlNo="31" :isDialog="1" @callback="beforeRoutJump">
                            <el-input
                                    v-model="formInline.client_code"
                                    readonly
                                    :placeholder="$t('getapi[2610]')"
                            >
                                <i class="el-icon-edit el-input__icon" slot="suffix" @click="doTheThing"></i>
                            </el-input>
                            </routejump>
                        </td>
                        <td>{{$t('getapi[163]')}}</td>
                        <td>
                            <routejump :urlNo="6" :isDialog="1" @callback="beforeRoutJump">
                            <el-input
                                    v-model="formInline.item_des"
                                    readonly
                                    :placeholder="$t('getapi[163]')"
                            >
                                <i class="el-icon-edit el-input__icon" slot="suffix" @click="doplanuser"></i>
                            </el-input>
                            </routejump>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[3139]')}}</td>
                        <td>
                            <!-- <el-input v-model="formInline.item_duty_person" type="text" size="mini" ></el-input> -->


                            <routejump :urlNo="6" :isDialog="1" @callback="beforeRoutJump">
                            <el-input
                                    v-model="formInline.item_duty_person"
                                    readonly
                            >
                                <i class="el-icon-edit el-input__icon" slot="suffix" @click="EmployeeInfo(5)"></i>
                            </el-input>
                            </routejump>
                        </td>
                        <td>{{$t('getapi[3361]')}}</td>
                        <td>
                            <el-date-picker v-model="formInline.item_into_date" :placeholder="$t('getapi[3361]')" type="date" size="mini"
                                            style="width:100%"></el-date-picker>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[6481]')}}</td>
                        <td>
                            <el-select v-model="formInline.trace" style="width:100%">
                                <el-option :label="$t('getapi[2052]')" :value="1"></el-option>
                                <el-option :label="$t('getapi[2053]')" :value="0"></el-option>
                            </el-select>
                        </td>
                        <td>{{$t('getapi[6873]')}}</td>
                        <td><el-input v-model="formInline.prefix" type="text" size="mini" ></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[6874]')}}</td>
                        <td>
                            <el-input v-model="formInline.serial_number" type="text" size="mini" ></el-input>
                        </td>
                        <td>{{$t('getapi[6872]')}}</td>
                        <td><el-select v-model="formInline.trace_in">
                            <el-option :label="$t('getapi[2052]')" :value="1"></el-option>
                            <el-option :label="$t('getapi[2053]')" :value="0"></el-option>
                        </el-select></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[6871]')}}</td>
                        <td>
                            <routejump :urlNo="6" :isDialog="1" @callback="beforeRoutJump">
                            <el-input
                                    v-model="formInline.quser_name"
                                    readonly
                            >
                                <i class="el-icon-edit el-input__icon" slot="suffix" @click="doqualityuser(1)"></i>
                            </el-input>
                            </routejump>
                        </td>
                        <td>{{$t('getapi[9744]')}}</td>
                        <td><el-input v-model="formInline.cost_customer_code" type="text" size="mini" ></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[12984]')}}</td>
                        <td>
                            <el-input v-model="formInline.device_name" type="text" size="mini" ></el-input>
                        </td>
                        <td>{{$t('getapi[12900]')}}</td>
                        <td><el-checkbox  v-model="formInline.isadd_docnode" :true-label=1 :false-label=0></el-checkbox></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[13153]')}}</td>
                        <td><el-input v-model="formInline.supplier_code" type="text" size="mini" ></el-input></td>
                        <td>{{$t('getapi[13517]')}}</td>
                        <td>
                            <el-checkbox v-model="formInline.autocalcmaterial" :true-label=1 :false-label=0 ></el-checkbox>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[13535]')}}</td>
                        <td>
                            <el-checkbox v-model="formInline.nofa" :true-label=1 :false-label=0 ></el-checkbox>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="4"><el-divider  content-position="left"><span style="font-weight:bold">{{$t('getapi[13166]')}}</span></el-divider></td>
                    </tr>
                    <tr>    
                        <td>{{$t('getapi[13113]')}}</td>
                        <td>
                            <routejump :urlNo="6" :isDialog="1" @callback="beforeRoutJump">
                            <el-input
                                    v-model="formInline.material_planner"
                                    readonly
                            >
                                <i class="el-icon-edit el-input__icon" slot="suffix" @click="materialplanneruser"></i>
                            </el-input>
                            </routejump>
                        </td>
                        
                        <td>{{$t('getapi[13114]')}}</td>
                        <td>
                            <routejump :urlNo="6" :isDialog="1" @callback="beforeRoutJump">
                            <el-input
                                    v-model="formInline.item_assistant"
                                    readonly
                            >
                                <i class="el-icon-edit el-input__icon" slot="suffix" @click="itemassistantuser"></i>
                            </el-input>
                            </routejump>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[12766]')}}</td>
                        <td>
                            <routejump :urlNo="6" :isDialog="1" @callback="beforeRoutJump">
                            <el-input
                                    v-model="formInline.job_design_person"
                                    readonly
                            >
                                <i class="el-icon-edit el-input__icon" slot="suffix" @click="jobdesignuser"></i>
                            </el-input>
                            </routejump>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="4"><el-divider  content-position="left"><span style="font-weight:bold">{{$t('getapi[13167]')}}</span></el-divider></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[13171]')}}</td>
                        <td>
                            <routejump :urlNo="6" :isDialog="1" @callback="beforeRoutJump">
                                <el-input
                                        v-model="formInline.remark"
                                        readonly
                                >
                                    <i class="el-icon-edit el-input__icon" slot="suffix" @click="doqualityuser(4)"></i>
                                </el-input>
                            </routejump>
                        </td>
                        <td>{{$t('getapi[13172]')}}</td>
                        <td>
                            <routejump :urlNo="6" :isDialog="1" @callback="beforeRoutJump">
                                <el-input
                                        v-model="formInline.item_pur_person_name"
                                >
                                    <i class="el-icon-edit el-input__icon" slot="suffix" @click="doqualityuser(2)"></i>
                                </el-input>
                            </routejump>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[13173]')}}</td>
                        <td>
                            <routejump :urlNo="6" :isDialog="1" @callback="beforeRoutJump">
                                <el-input
                                        v-model="formInline.item_sale_person_name"
                                >
                                    <i class="el-icon-edit el-input__icon" slot="suffix" @click="doqualityuser(3)"></i>
                                </el-input>
                            </routejump>
                        </td>
                    </tr>
                </table>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
				<el-button size="small" @click="editvisi = false">{{ $t('getapi[6]') }}</el-button>
				<el-button size="small" type="primary" @click="sava" :loading="loading"
                           :disabled="loading">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="statusvisi" :title="$t('getapi[552]')" width="20%" :close-on-click-modal="false">
            <div>
                <el-button type="primary" size="mini" @click="confirmChangestatus(0)">{{$t('getapi[3362]')}}</el-button>
                <el-button type="primary" size="mini" @click="confirmChangestatus(1)">{{$t('getapi[3363]')}}</el-button>
                <el-button type="primary" size="mini" @click="confirmChangestatus(2)">{{$t('getapi[3364]')}}</el-button>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button size="small" @click="statusvisi = false">{{ $t('getapi[6]') }}</el-button>
			</span>
        </el-dialog>
        <!-- 编辑弹框 -->
        <!-- 物料弹框 -->
        <salcus :isVisible="salcurvisi" @getsalcus="getsalcur" ref="input"></salcus>
        <!--计划员-->
        <selector
                :isVisible="planuserVisible"
                :isBatch="false"
                :selectType="0"
                :isSplitPage="true"
                :postUrl="'/Basic/Popup/GetPlanUsersPopuDataList'"
                @callback="getplanuser"
                ref="employee"
        ></selector>
        <!--计划员-->
        <selector
                :isVisible="qualityuservisible"
                :isBatch="false"
                :selectType="0"
                :isSplitPage="true"
                :postUrl="'/Basic/Popup/GetQualityUsersPopuDataList'"
                @callback="getqualityuser"
                ref="qualityuser"
        ></selector>
        <selector
                :isVisible="EmployeeInfovisible"
                :isBatch="false"
                :selectType="0"
                :isSplitPage="true"
                :postUrl="'/Basic/Popup/GetEmployeeInfoPopuDataList'"
                @callback="getEmployeeInfo"
                ref="EmployeeInfo"
        ></selector>
        
        <selector
                :isVisible="jobdesignuservisible"
                :isBatch="false"
                :selectType="0"
                :isSplitPage="true"
                :postUrl="'/Basic/Popup/GetQualityUsersPopuDataList'"
                @callback="getjobdesignuser"
                ref="jobdesignuser"
        ></selector>

        <selector
                :isVisible="materialplanneruservisible"
                :isBatch="false"
                :selectType="0"
                :isSplitPage="true"
                :postUrl="'/Basic/Popup/GetQualityUsersPopuDataList'"
                @callback="getmaterialplanneruser"
                ref="materialplanneruser"
        ></selector>

        <selector
                :isVisible="itemassistantuservisible"
                :isBatch="false"
                :selectType="0"
                :isSplitPage="true"
                :postUrl="'/Basic/Popup/GetQualityUsersPopuDataList'"
                @callback="getitemassistantuser"
                ref="itemassistantuser"
        ></selector>

        

    </div>
</template>

<script>
    import Common from '@/components/Common';

    export default {
        name: 'itemprolist',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3 - Common.reduceTableHeight2
            }
        },
        data() {
            return {
                formInline: {
                    exclusively_id: 0,
                    item_code: '',
                    item_name: '',
                    item_shortname: '',
                    client_code: '',
                    item_des: '',
                    item_recept_person: '',
                    item_duty_person: '',
                    item_into_date: '',
                    item_status_code: '',
                    create_person: '',
                    create_time: '',
                    modify_person: '',
                    modify_time: '',
                    remark: '',
                    item_status: 0,
                    trace: 0,
                    prefix: '',
                    serial_number: '',
                    trace_in: 0,
                    quser_num: 0,
                    quser_name:'',
                    job_design_person:'',
                    device_name:'',
                    item_assistant:'',
                    material_planner:'',
                    supplier_code:'',
                    autocalcmaterial:0,
                    nofa:0,
                },
                oldFormInline:[],
                ids: '',
                showloading: '',
                isVisible: false,
                editvisi: false,
                addoredit: 1, //新增1，修改2
                DbTbNames: '', //表名
                datajson: [],
                PageIndex: 1,
                PageSize: this.$http.getPageSize('itemprolist'),
                SelectIndex: 1,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                isShowEdit: false, // 是否显示编辑页面
                dataSetDetail: {}, // 编辑页面数据详情
                queryData: [], // 查询数组
                selectIDData: '', // 选择的数据的ID集合
                selectData: [],
                tracetype: 0, //跟踪类别
                url: '', // 零件图路径
                isEdit: true, // 是否新增
                salcurvisi: false,
                btn: {
                    del: false,
                    edit: false,
                    checkPic: false,
                    editstatus:false,//修改状态
                },
                userData: [],
                user: '',
                planuserVisible: false,
                qualityuservisible:false,
                EmployeeInfovisible:false,
                jobdesignuservisible:false,
                materialplanneruservisible:false,
                itemassistantuservisible:false,
                selectrow: {},
                statusvisi: false,
                scrollTop:0,
                persontype:1,//1:质量负责人2:采购负责人3:销售负责人
            };
        },
        create() {
        },
        beforeMount() {
            console.log('beforeMount');
            //this.getqwlist();
        },
        watch: {
            datajson: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted() {
            console.log('mounted');
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.user = JSON.parse(that.userData).username;
            that.intidata();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1091]"),this.$t("getapi[11]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.btn.editstatus=false;
                if(that.$limits.authority('plv4', 89, 1)>0){
                    that.btn.editstatus=true;
                }
                else{
                    that.btn.editstatus=false;
                }

                //只读权
                if (that.$limits.ReadOnlyRights('plv2', 26, 1)) {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                }
                //操作权
                let ilimits = that.$limits.UnOperationAuthority('plv2', 26, 1);
                // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
                switch (ilimits) {
                    case 1:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        break;
                    case 2:
                        that.btn.edit = true;
                        that.btn.del = false;
                        that.$refs.SetBtn.SetButtonEnable('create,search,save,refresh,export');
                        break;
                    case 3:
                        that.btn.edit = true;
                        that.btn.del = true;
                        that.$refs.SetBtn.SetButtonEnable('create,search,save,del,refresh,export');
                        break;
                    default:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        break;
                }
            },
            btnauthority() {
                let that = this
                that.btn.checkPic = false
                if (that.selectData.length > 0) {
                    that.btn.checkPic = true
                }
            },
            //客户弹框
            doTheThing() {
                this.salcurvisi = true;
                this.$refs.input.clearInput(this.salcurvisi);
            },
            //获取客户信息
            getsalcur(val) {
                this.formInline.client_code = val.Customer_ID;
                // this.formInline.part_code = val.Customer_Name;
                // this.formInline.part_name = val.ShortName;
            },
            //计划员弹框
            doplanuser() {
                this.planuserVisible = true;
                this.$refs.employee.clearInput(this.planuserVisible);
            },
            //计划员
            getplanuser(data) {
                let that = this;
                that.formInline.item_des = data.name;
            },
            //质量负责人弹框
            doqualityuser(type) {
                let that = this
                that.persontype = type
                this.qualityuservisible = true;
                this.$refs.qualityuser.clearInput(this.qualityuservisible);
            },
            EmployeeInfo(type) {
                let that = this
                that.persontype = type
                this.EmployeeInfovisible = true;
                this.$refs.EmployeeInfo.clearInput(this.EmployeeInfovisible);
            },
            getEmployeeInfo(data){
                let that = this;
                if(that.persontype == 5){
                    that.formInline.item_duty_person = data.name;
                }
            },
            //质量负责人
            getqualityuser(data) {
                let that = this;
                if(that.persontype == 1){
                    that.formInline.quser_name = data.name;
                    that.formInline.quser_num = data.userid;
                } else if(that.persontype == 2){
                    that.formInline.item_pur_person_name = data.name;
                    that.formInline.item_pur_person_id = data.userid;
                } else if(that.persontype == 3) {
                    that.formInline.item_sale_person_name = data.name;
                    that.formInline.item_sale_person_id = data.userid;
                } else if(that.persontype == 4){
                    that.formInline.remark = data.name;
                    that.formInline.remark_id = data.userid;
                }
            },

            //工装设计人弹框
            jobdesignuser() {
                this.jobdesignuservisible = true;
                this.$refs.jobdesignuser.clearInput(this.jobdesignuservisible);
            },
            //工装设计人
            getjobdesignuser(data) {
                let that = this;
                that.formInline.job_design_person = data.name+'('+data.code+')';

            },

            //物料计划员弹框
            materialplanneruser() {
                console.log("测试22")
                this.materialplanneruservisible = true;
                this.$refs.materialplanneruser.clearInput(this.materialplanneruservisible);
            },
            //物料计划员
            getmaterialplanneruser(data) {
                let that = this;
                console.log("测试11")
                that.formInline.material_planner = data.name+'('+data.code+')';

            },

            //项目助理弹框
            itemassistantuser() {
                console.log("测试2")
                this.itemassistantuservisible = true;
                this.$refs.itemassistantuser.clearInput(this.itemassistantuservisible);
            },
            //项目助理
            getitemassistantuser(data) {
                let that = this;
                console.log("测试1")
                that.formInline.item_assistant = data.name+'('+data.code+')';

            },
            //获取查询条件
            serclick(val) {
                console.log(val);
                this.queryData = val;
                this.intidata();
                this.authority();
            },
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.$http.savePageSize('itemprolist',val)
                this.intidata();
                this.authority();
            },
            //跳页m
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.intidata();
                this.authority();
            },
            //编辑
            editInfo(row) {
                let that = this;
            },
            // 获取数据
            intidata() {
                let that = this;
                that.loading = true;
                this.isVisible = false;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                that.queryData.forEach(item => {
                    pm = {
                        row_sign: item.row_sign,
                        query_Condition: item.query_Condition,
                        query_sort: item.query_sort,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
                    //}
                });
                console.log(parm);
                that.$http.urlpost('Basic/Items/ItemDataList', parm, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.datajson = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                    that.authority();
                });
            },
            // 保存数据
            sava() {
                let that = this;
                that.loading = true;
                let parm ={
                    model:that.formInline,
                    LangType:that.$processdata.getLang()
                }
                // parm.push(that.formInline);
                console.log(JSON.stringify(parm));
                that.$http.urlpost('Basic/Items/SaveItem', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[284]'));
                        that.editvisi = false;
                        that.intidata();
                    }
                    that.loading = false;
                });
            },
            // 获取查询条件
            getqwlist() {
                let that = this;
                that.$http.urlpost('Basic/Items/ItemQWList', {}, function (res) {
                    that.queryData = res.DataContent;
                });
            },
            // 编辑
            edit(jsd) {
                let that = this
                console.log(jsd);
                this.editvisi = true;
                that.addoredit = 2
                this.formInline = {
                    item_code: jsd.row.ITEM_CODE,
                    item_name: jsd.row.ITEM_NAME,
                    // item_shortname:  jsd.row.ITEM_CODE,
                    client_code: jsd.row.CLIENT_CODE,
                    item_des: jsd.row.ITEM_DES,
                    // item_recept_person:  jsd.row.ITEM_CODE,
                    item_duty_person: jsd.row.ITEM_DUTY_PERSON,
                    item_into_date: jsd.row.ITEM_INTO_DATE,
                    // item_status_code:  jsd.row.ITEM_CODE,
                    create_person: jsd.row.create_person,
                    create_time: jsd.row.create_time,
                    modify_person: jsd.row.modify_person,
                    modify_time: jsd.row.MODIFY_TIME,
                    remark: jsd.row.REMARK,
                    remark_id: jsd.row.REMARK_ID,
                    item_status: jsd.row.Item_Status,
                    trace: jsd.row.trace,
                    prefix: jsd.row.prefix,
                    serial_number: jsd.row.serial_number,
                    trace_in: jsd.row.trace_in,
                    quser_num: jsd.row.QUser_Num,
                    quser_name: jsd.row.QUser_Num_Name,
                    exclusively_id: jsd.row.Exclusively_Id,
                    cost_customer_code:jsd.row.cost_customer_code,
                    job_design_person:jsd.row.job_design_person,
                    isadd_docnode:jsd.row.isadd_docnode,
                    device_name:jsd.row.device_name,
                    item_assistant:jsd.row.item_assistant,
                    material_planner:jsd.row.material_planner,
                    item_pur_person_name: jsd.row.ITEM_PUR_PERSON_NAME,
                    item_pur_person_id: jsd.row.ITEM_PUR_PERSON_ID,
                    item_sale_person_name: jsd.row.ITEM_SALE_PERSON_NAME,
                    item_sale_person_id: jsd.row.ITEM_SALE_PERSON_ID,
                    supplier_code:jsd.row.supplier_code,
                    autocalcmaterial:jsd.row.autocalcmaterial,
                    nofa:jsd.row.nofa,
                };
                that.oldFormInline = JSON.stringify(that.formInline)
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = '';
                that.selectData = []
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData += val[i].Exclusively_Id + ',';
                    that.selectData = [...that.selectData,{
                        Exclusively_Id: val[i].Exclusively_Id,
                        ITEM_CODE: val[i].ITEM_CODE,
                        ITEM_NAME: val[i].ITEM_NAME,
                        CLIENT_CODE: val[i].CLIENT_CODE,
                        ITEM_DES: val[i].ITEM_DES,
                        ITEM_DUTY_PERSON: val[i].ITEM_DUTY_PERSON,
                        ITEM_INTO_DATE: val[i].ITEM_INTO_DATE,
                        REMARK: val[i].REMARK,
                        REMARK_ID: val[i].REMARK_ID,
                        Item_Status: val[i].Item_Status,
                        UsedIn: val[i].QUser_Num,
                        create_person: val[i].create_person,
                        create_time: val[i].create_time,
                        modify_person: val[i].modify_person,
                        MODIFY_TIME: val[i].MODIFY_TIME,
                        trace: val[i].trace,
                        trace_name: val[i].trace_name,
                        prefix: val[i].prefix,
                        serial_number: val[i].serial_number,
                        trace_in: val[i].trace_in,
                        trace_in_name: val[i].trace_in_name,
                        item_pur_person_name: val[i].ITEM_PUR_PERSON_NAME,
                        item_pur_person_id: val[i].ITEM_PUR_PERSON_ID,
                        item_sale_person_name: val[i].ITEM_SALE_PERSON_NAME,
                        item_sale_person_id: val[i].ITEM_SALE_PERSON_ID,
                        supplier_code:val[i].supplier_code,
                        autocalcmaterial:val[i].autocalcmaterial,
                        nofa:val[i].nofa,
                    }]
                }
                console.log(that.selectIDData);
                that.btnauthority()
            },
            // 删除
            delf() {
                let that = this;
                let parm = {
                    ids: that.ids
                };
                console.log(parm);
                that.$http.urlpost('Basic/Items/DeleteItemByID', parm, function (res) {
                    that.intidata();
                    that.$message.success(that.$t('getapi[659]'));
                });
            },
            changestatus(row){
                let that = this
                that.selectrow = row.row
                that.statusvisi = true
            },
            confirmChangestatus(val) {
                let that = this;
                let status = val;
                let parm = {
                    item_code: that.selectrow.ITEM_CODE,
                    item_status: status
                };
                that.$http.urlpost('Basic/Items/UpdateItemStatusBycode', parm, function (res) {
                    that.intidata();
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    that.statusvisi = false
                });
            },
            // 删除
            del(jsd) {
                this.ids = jsd.row.Exclusively_Id + ',';
                this.delf();
            },
            //批量删除
            delall() {
                let that = this;
                that.ids = this.selectIDData;
                that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该数据, 是否继续?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.delf();
                    })
                    .catch(() => {
                    });
            },
            // 新增
            add() {
                let that = this
                let datetime = Common.methods.getDatetime();
                this.formInline = {
                    exclusively_id: 0,
                    item_code: '',
                    item_name: '',
                    item_shortname: '',
                    client_code: '',
                    item_des: '',
                    item_recept_person: '',
                    item_duty_person: '',
                    item_into_date: '',
                    item_status_code: '',
                    create_person: that.user,
                    create_time: datetime,
                    modify_person: that.user,
                    modify_time: datetime,
                    remark: '',
                    remark_id:'',
                    item_status: 0,
                    trace: 0,
                    prefix: '',
                    serial_number: '',
                    trace_in: 0,
                    quser_num: 0,
                    quser_name:'',
                    cost_customer_code: '',
                    job_design_person:'',
                    isadd_docnode:0,
                    device_name:'',
                    item_assistant:'',
                    material_planner:'',
                    item_pur_person_name: '',
                    item_pur_person_id: '',
                    item_sale_person_name: '',
                    item_sale_person_id: '',
                    supplier_code:'',
                    autocalcmaterial:0,
                    nofa:0,
                };
                that.addoredit = 1
                this.editvisi = true;
            },
            // 查询
            search() {
                this.isVisible = true;
                this.$refs.ser.clearInput(this.isVisible, 'ENGITEMLineViewInfo');
            },
            // 刷新
            reflash() {
                this.intidata();
            },
            //导出·
            exp() {
                let that = this;
                that.loading = true;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: [],
                    LangType:that.$processdata.getLang(),
                    fromname: that.$t('getapi[1091]')
                };
                that.queryData.forEach(item => {
                    //if(item.query_Condition==''||item.query_Condition.length>0) {
                    pm = {
                        row_sign: item.row_sign,
                        query_Condition: item.query_Condition,
                        query_sort: item.query_sort,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
                    //}
                });
                console.log(JSON.stringify(parm));
                that.$http.urlpost('Basic/Items/ItemExportToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
            },
            //检查工艺图纸
            checkPic(){
                let that = this
                this.$confirm(that.$t('getapi[8604]'), that.$t('getapi[194]'), {//'请确认是否要操作（将会检查项目下的所有图纸）?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = that.selectData
                        that.$http.urlpost('/Basic/Items/CheckPic', parm, function (res) {
                            if(res.Success == 1){
                                that.intidata();
                                that.$message.success(that.$t('getapi[8916]'));//'完成！'
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
            },
            // 检查零件图
            checkPart(){
                let that = this
                this.$confirm(that.$t('getapi[8604]'), that.$t('getapi[194]'), {//'请确认是否要操作（将会检查项目下的所有图纸）?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let arr = []
                        for(let i=0;i<that.selectData.length;i++){
                            arr = [...arr,{
                                item_code: that.selectData[i].ITEM_CODE
                            }]
                        }
                        let parm = {
                            list: arr
                        }
                        that.$http.urlpost('/Basic/Items/CheckPartDrawing', parm, function (res) {
                            if(res.Success == 1){
                                that.intidata();
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
            },
            beforeRoutJump(val,callback){
                let that = this
                if(that.oldFormInline != JSON.stringify(that.formInline)){
                    this.$confirm(that.$t('getapi[12830]'), that.$t('getapi[194]'), {
                        confirmButtonText: that.$t('getapi[1146]'),
                        cancelButtonText: that.$t('getapi[2054]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.isVisible = false
                            callback(true)
                        })
                        .catch(() => {
                            this.$message({
                                type: 'info',
                                message: that.$t('getapi[6096]')
                            });
                        });
                } else {
                    that.isVisible = false
                    callback(true)
                }
            },
        }
    };
</script>

<style lang="scss" scoped>

    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
